import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Archive } from 'src/config/api/models/Archive';
import apiRoutesV2, { baseURL } from 'src/config/api/routes';
import { RootState } from 'src/modules/shared/store';

export const archiveApi = createApi({
  reducerPath: 'archiveApi',
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.jwt;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getArchive: builder.query<Archive[], void>({
      query: () => ({
        url: apiRoutesV2.getArchive(),
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetArchiveQuery } = archiveApi;
